exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/Angular/Urbanos/src/app/exploracion/exploracion.component.css
// module id = ../../../../../src/app/exploracion/exploracion.component.css
// module chunks = main